import { motion } from 'framer-motion';

const audiences = [
  'Enterprise organisations',
  'Institutional leadership teams',
  'Sovereign and regional initiatives',
  'Emerging ventures',
  'Infrastructure groups',
  'Future-focused investment entities',
];

const WhoWeWorkWith = () => {
  return (
    <section className="relative py-16 lg:py-20" data-testid="who-we-work-with">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs uppercase tracking-[0.3em] mb-4" style={{ color: 'rgba(201,162,39,0.5)' }}>
              Selective Engagement
            </p>
            <h3
              className="text-xl md:text-2xl font-light tracking-[0.1em] text-white mb-8"
              style={{ fontFamily: "'Cinzel', serif" }}
            >
              Who We Work With
            </h3>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="mb-8"
          >
            <p className="text-sm mb-6" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Celestial Minds&#8482; engages selectively with:
            </p>
            <div className="flex flex-wrap justify-center gap-3 mb-8">
              {audiences.map((a) => (
                <span
                  key={a}
                  className="px-4 py-2 text-xs tracking-wider"
                  style={{
                    border: '1px solid rgba(201,162,39,0.15)',
                    color: 'rgba(255,255,255,0.6)',
                    borderRadius: '2px',
                    background: 'rgba(10,22,40,0.3)',
                  }}
                >
                  {a}
                </span>
              ))}
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.45)' }}>
              Our work is designed for organisations preparing for structural transformation in the era of artificial intelligence, economic transition, and long-horizon systems evolution.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeWorkWith;
